<template>
	<header class="main-header">
		<div class="logo-holder">
			<router-link to="/">
				<picture class="logo">
					<source srcset="/images/front/logo-light.svg" media="(prefers-color-scheme: dark)">
					<img src="/images/front/logo-dark.svg" />
				</picture>
			</router-link>
		</div>
		<div class="container">
			<div class="row">
				<div class="col-24">
					<nav class="menu">
						<router-link to="/">Home</router-link>
						<router-link to="/about">About</router-link>
						<router-link to="/recipes">Recipes</router-link>
						<router-link to="/posts">Posts</router-link>
						<router-link to="/contact">Contact</router-link>
					</nav>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	export default {

	}
</script>